module.exports = "/packs/images/svg/ireland/facilities/golf~cff1a11c096b70421771e22c098ced95.svg";